import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.define-property";
import "core-js/modules/web.dom-collections.for-each";

var Column =
/** @class */
function () {
  function Column(idx, width, left, cubedHeight, infoWidth) {
    this.idx = idx;
    this.groups = [];
    this.height = 0;
    this.width = width;
    this.left = left;
    this.cubedHeight = cubedHeight;
    this.infoWidth = infoWidth || 0;
  }

  Column.prototype.addGroup = function (group) {
    this.addGroups([group]);
  };

  Column.prototype.addGroups = function (groups) {
    var _this = this;

    this.groups = this.groups.concat(groups);
    groups.forEach(function (group) {
      group.columnIdx = _this.idx;
      group.Column = _this;
    });
  };

  Object.defineProperty(Column.prototype, "totalWidth", {
    get: function get() {
      return this.width + this.infoWidth;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Column.prototype, "scheme", {
    get: function get() {
      return {
        idx: this.idx,
        groups: this.groups.map(function (group) {
          return group.scheme;
        }),
        width: this.width,
        height: this.height
      };
    },
    enumerable: false,
    configurable: true
  });
  return Column;
}();

export { Column };